export const safetyForm = `
<style>
    #safetyForm th {
        text-align: left;
    }
    #safetyForm .explanation {
        font-size: 1em;
        font-weight: normal;
        font-style: italic;
    }
</style>

<div id="safetyForm">
<table style="width: 100%">
    <tr>
        <th>Select reagents kind</th>
        <td>
            <input type="radio" value="all" name="reagentsKind"> All
            <input type="radio" value="nonWorkup" name="reagentsKind"> Not workup
            <input type="radio" value="onlyWorkup" name="reagentsKind"> Only work-up
        </td>
    </tr>
    <tr>
        <th>
            Dust risk<br>
            <div class="explanation">More than 5g</div>
        </th>
        <td>
            <input type="radio" value="none" name="dustRisk"> None
            <input type="radio" value="yes" name="dustRisk">  Fine powders, fibers air suspended
        </td>
    </tr>
    <tr>
        <th>Reaction time</th>
        <td>
            <input type="radio" value="daytime" name="reactionTime"> Day-time  
            <input type="radio" value="overnight" name="reactionTime"> Overnight
        </td>
    </tr>
    <tr>
        <th>Temperature</th>
        <td>
            <input type="radio" value="<100" name="temperature"> &lt;100°C
            <input type="radio" value="100-200" name="temperature"> 100-200°C
            <input type="radio" value="extreme" name="temperature"> &gt;200 or &lt;-30°C
        </td>
    </tr>
    <tr>
        <th>
            Handling high pressure gas lines
             <div class="explanation">(gas line presure)</div>
        </th>
        <td>
            <table>
                <tr>
                    <td>
                        Inert (e.g., N<sub>2</sub>, He, Ar, CO<sub>2</sub>)
                    </td>
                    <td>
                        <input type="radio" value="none" name='gasLines.inert'> None
                    </td>
                    <td>
                        <input type="radio" value="<20" name='gasLines.inert'> &lt;20 barg
                    </td>
                    <td>
                        <input type="radio" value="20-40" name='gasLines.inert'> 20-40 barg
                    </td>
                    <td>
                        <input type="radio" value=">40" name='gasLines.inert'> &gt;40 barg
                    </td>
                </tr>
                <tr>
                    <td>
                        Reactive/Hazardous (e.g., CO, NH<sub>3</sub>, H<sub>2</sub>, hydrocarbons)
                    </td>
                    <td>
                        <input type="radio" value="none" name='gasLines.reactive'> None
                    </td>
                    <td>
                        <input type="radio" value="<20" name='gasLines.reactive'> &lt;20 barg
                    </td>
                    <td>
                        <input type="radio" value="20-40" name='gasLines.reactive'> 20-40 barg
                    </td>
                    <td>
                        <input type="radio" value=">40" name='gasLines.reactive'> &gt;40 barg
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <th>Pressure</th>
        <td>
            <table>
                <tr>
                    <td>Parr <= 50 mL or flow reactor (1/4”)
                    </td>
                    <td>
                        <input type="radio" value="none" name="pressure.parrLow"> None
                        <input type="radio" value="1-20" name="pressure.parrLow"> 1-20 barg
                        <input type="radio" value="20-100" name="pressure.parrLow"> 20-100 barg
                        <input type="radio" value="100-120" name="pressure.parrLow"> 100-120 barg
                        <input type="radio" value=">120" name="pressure.parrLow"> &gt;120 barg
                    </td>
                </tr>
                <tr>
                    <td>Parr > 50 mL or flow reactor (1/2”)
                    </td>
                    <td>
                        <input type="radio" value="none" name="pressure.parrHigh"> None
                        <input type="radio" value="yes" name="pressure.parrHigh"> Yes
                    </td>
                </tr>
                <tr>
                    <td>Glass (P-Rated)
                    </td>
                    <td>
                        <input type="radio" value="none" name="pressure.pRated"> None
                        <input type="radio" value="1-3" name="pressure.pRated"> 1-3 barg
                        <input type="radio" value="3-5" name="pressure.pRated">3-5 barg
                        <input type="radio" value="5-8" name="pressure.pRated">5-8 barg
                        <input type="radio" value=">8" name="pressure.pRated"> &gt;8 barg
                    </td>
                </tr>
                <tr>
                    <td>Glass (not-Rated)
                    </td>
                    <td>
                        <input type="radio" value="none" name="pressure.nonRated"> None
                        <input type="radio" value="yes" name="pressure.nonRated"> Yes
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    
    <tr>
        <th>Overhead stirring ?</th>
        <td>
            <input type="radio" value="none" name="overheadStirring"> None
            <input type="radio" value="yes" name="overheadStirring"> Yes
        </td>
    </tr>
    
    <tr>
        <th>High voltage ?</th>
        <td>
            <input type="radio" value="none" name="highVoltage"> None
            <input type="radio" value="yes" name="highVoltage"> Yes
        </td>
    </tr>
</div>`;
